import { createSlice } from '@reduxjs/toolkit';
import INVALID_VALID_MAPPING from '@inter-ikea-guida/pax-catalog/mapping.json';
import { keyBy } from '@inter-ikea-guida/utils';
import { constructProduct } from '../../features/products';
const initialState = {
    byIds: {},
    productsFetched: false,
    selectedProduct: null
};
/**
 * A collection of products that are invalid and should be replaced with another product.
 * The @key is the product that should be replaced and the @value is the product that should replace it.
 */
const INVALID_PRODUCTS_TO_ADD = INVALID_VALID_MAPPING;
/**
 * Construct fake products for the invalid products.
 * @param products The products to construct fake products from.
 * @returns The fake products.
 */
const constructFakeProducts = (products) => {
    const validProducts = products
        .filter(art => Object.values(INVALID_PRODUCTS_TO_ADD).includes(art.id))
        .map(art => {
        return {
            ...art,
            replacementFor: Object.keys(INVALID_PRODUCTS_TO_ADD).find(key => INVALID_PRODUCTS_TO_ADD[key] === art.id)
        };
    });
    const fakeProductsFromValid = validProducts.map(art => {
        if (art.replacementFor) {
            return {
                ...art,
                id: art.replacementFor,
                product: {
                    ...art.product
                }
            };
        }
    });
    return fakeProductsFromValid;
};
export const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        fetchProducts: (state, action) => {
            const products = action.payload.map(constructProduct);
            const addFakesToProducts = [...products, ...constructFakeProducts(products)];
            const byIds = keyBy(addFakesToProducts, 'id');
            return { ...state, byIds, productsFetched: true };
        },
        unselectProduct: state => {
            return {
                ...state,
                selectedProduct: null
            };
        },
        selectProduct(state, action) {
            const product = {
                ...action.payload
            };
            return {
                ...state,
                selectedProduct: product
            };
        }
    }
});
export const { fetchProducts, selectProduct, unselectProduct } = productsSlice.actions;
export const { reducer } = productsSlice;
//# sourceMappingURL=index.js.map